import {Condition} from "../engine/Condition";
import {Dispatcher} from "../../../../stem-core/src/base/Dispatcher";
import {detectAdBlock} from "../../../utils/detectAdBlock";

let initializedAdBlockDetection = false;
let adBlockDetected = null;
let adBlockDetectionDispatcher = new Dispatcher();


export class AdBlockEnabledCondition extends Condition {
    constructor(...args) {
        super(...args);

        if (!initializedAdBlockDetection) {
            // This condition is stateless, but we still want to run adblock detection only once.
            detectAdBlock(() => adBlockDetectionDispatcher.dispatch(true),
                () => adBlockDetectionDispatcher.dispatch(false));
            initializedAdBlockDetection = true;
        }

        if (adBlockDetected == null) {
            this.attachListenerOnce(adBlockDetectionDispatcher, (value) => {
                adBlockDetected = value;
                this.requestReEval();
            });
        }
    }

    evaluate() {
        return adBlockDetected;
    }
}
